import { useTranslation } from 'react-i18next';
import { QueryKeys } from '@connect-x-app/shared-domain-models';
import { deleteQuickReply } from '@connect-x-app/web-data-access';
import { toastError, toastSuccess } from '@connect-x-app/web-ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useDeleteQuickReplies = () => {
  const queryClient = useQueryClient();

  const { t } = useTranslation();

  const mutation = useMutation({ mutationFn: deleteQuickReply, mutationKey: [QueryKeys.QUICK_REPLIES] });

  const deleteSelectedQuickReplies = async (ids: string[]) => {
    const results = await Promise.allSettled(ids.map(id => mutation.mutateAsync(id)));

    queryClient.invalidateQueries({ queryKey: [QueryKeys.QUICK_REPLIES] });

    const fulfilled = results.filter(result => result.status === 'fulfilled');

    if (fulfilled.length !== results.length) {
      toastError(t('TOAST_ERROR'));
      return undefined;
    }

    toastSuccess(t('TOAST_SUCCESS'));
    return fulfilled.map(({ value }) => value);
  };

  return { ...mutation, deleteSelectedQuickReplies };
};
